<pages-container
  [title]="'main.parishOrganization'"
  [icon]="'account_balance'"
  [showSearch]="true"
  (onSearchSent)="handleSearch($event)">
  <div buttons>
    <button mat-raised-button
            [routerLink]="'/pages/settings/parishOrganization/detail'"
            class="mat-white-bg">
      <span>{{ 'parishOrganization.add_new' | translate }}</span>
    </button>
  </div>

  <div main-content class="table-container " id="eventPage">
    <mat-table class="products-table"
               #table
               [dataSource]="parishOrganizations()"
               matSort
               (matSortChange)="sortData($event)"
               (scroll)="onScroll($event)">

      <ng-container matColumnDef="title">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
          {{ 'canton.name' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let org" class="customWidthClass">
          <p class="text-truncate">{{ org.name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="country">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'canton.country' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let org">
          @if (org.country?.flag) {
            <img style="height: 40px" [src]="'assets/images/' + org.country.flag + '.svg'"/>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canton">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'main.canton' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let org">
          <p class="text-truncate">{{ org.city?.name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="responsible">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'parishOrganization.responsible' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let org">
          <p class="text-truncate">{{ org?.responsible_first_name }} {{ org?.responsible_last_name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="president">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
          {{ 'parishOrganization.president' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let org">
          <p class="text-truncate">{{ org?.president_first_name }} {{ org?.president_last_name }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell class="hide-on-mobile" *matHeaderCellDef mat-sort-header>
           {{ 'parishOrganization.status' | translate }}
        </mat-header-cell>
        <mat-cell class="hide-on-mobile" *matCellDef="let org">
          <mat-icon [style.color]="org.status ? 'green' : 'red'">
            {{ org.status ? 'done' : 'close' }}
          </mat-icon>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></mat-header-row>
      <mat-row *matRowDef="let org; columns: displayedColumns();"
               class="event-row"
               matRipple
               [routerLink]="['/pages/settings/parishOrganization/detail']"
               [queryParams]="{id: org.id}">
      </mat-row>

    </mat-table>
    <mat-paginator [length]="pagination()?.total"
                   [pageIndex]="pageIndex()"
                   [pageSize]="perPage()"
                   [pageSizeOptions]="[10, 25, 50]"
                   (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
</pages-container>
